import { conditions, progressBarWidth } from "helpers";
import { ConditionName, zIndex } from "interfaces";
import {
    handleCatchUpLoadingLog,
    handleMouseMove,
    handleMouseOut,
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    hideProgressTooltip
} from "redux-share/actions/progressbar.actions";
import { useAppSelector } from "redux-share/hooks";
import Tooltip from "../../../player-components/tooltip/tooltip";
import Markers from "./markers/markers";
import { useEffect, useState } from "react";
import { shallowEqual } from "react-redux";
import dynamic from "next/dynamic";

const ViewersChart = dynamic(() => import("../../../player-components/viewersChart/viewersChart"));

const ProgressBar = () => {
    const [isPointerDown, setIsPointerDown] = useState<boolean>(false);

    useEffect(() => {
        hideProgressTooltip(document.querySelector(".progressTooltip"));
    }, []);

    const { duration, currentTime, bufferedTimeWidth, hlsLiveSyncPosition } = useAppSelector(
        ({ controller: { duration, currentTime, bufferedTimeWidth, hlsLiveSyncPosition, showMiniPlayer } }) => ({
            duration,
            currentTime,
            bufferedTimeWidth,
            hlsLiveSyncPosition,
            showMiniPlayer
        }),
        shallowEqual
    );
    const { markers } = useAppSelector(
        ({ videoData: { params, videoElementSizeInfo, markers, isComplexPortrait } }) => ({
            params,
            videoElementSizeInfo,
            markers,
            isComplexPortrait
        }),
        shallowEqual
    );
    const [timeoutIds, setTimeoutIds] = useState<any[]>([]);

    const durationTime = conditions(ConditionName.isLiveParam) ? hlsLiveSyncPosition : duration;
    const calculateMarkerPosition = (time: number) => (durationTime ? (progressBarWidth() * time) / durationTime : 0);

    return (
        <div className={`pl-relative pl-mb-2 ${conditions(ConditionName.isComplexPortrait) && "pl-mx-2"}`}>
            <div className="pl-relative">
                <Tooltip />
                <Markers />
            </div>
            <div
                className={`pl-w-full pl-absolute pl-bottom-0.5 pl-flex pl-items-end pl-pb-2`}
                onPointerDown={(event: any) => handlePointerDown(event, timeoutIds, setIsPointerDown)}
                onPointerMove={handlePointerMove}
                onPointerUp={(event: any) => handlePointerUp(event, setTimeoutIds, timeoutIds, setIsPointerDown)}
                onMouseMove={handleMouseMove}
                onMouseOut={handleMouseOut}
                onClick={handleCatchUpLoadingLog}
                onDoubleClick={(event: any) => event.stopPropagation()}
            >
                <div id="progress-area" className="pl-w-full pl-absolute">
                    {conditions(ConditionName.hasChart) && !conditions(ConditionName.isMiniPlayer) && <ViewersChart />}
                    <div
                        id="time-progress-area"
                        className={`!pl-w-full !pl-h-[5px] pl-transition-transform pl-duration-300 pl-m-auto pl-cursor-pointer !pl-bg-z-secondary-100/[0.4] pl-rounded`}
                        style={{ transform: isPointerDown ? "scaleY(1.8)" : "unset" }}
                    >
                        {markers.map((marker: any) => (
                            <div key={marker.id} data-marker={marker.time}>
                                <div
                                    className="pl-emoji-dot pl-absolute pl-flex pl-flex-col pl-w-[3px] pl-h-[5px] pl-bg-white pl-cursor-pointer"
                                    data-marker={marker.time}
                                    style={{ left: calculateMarkerPosition(marker.time), zIndex: zIndex.emoji }}
                                />
                            </div>
                        ))}
                        <div
                            id="time-progress-buffer"
                            className={`pl-absolute pl-h-[5px] pl-bg-z-gray-400/[0.7] pl-rounded`}
                            style={{ width: `${bufferedTimeWidth}%` }}
                        />
                        <div
                            id="time-progress-bar"
                            className={`pl-h-[5px] pl-rounded pl-relative pl-cursor-pointer pl-bg-red-zProgress before:pl-bg-red-zProgress before:pl-inline-block before:pl-w-4 before:pl-h-4 ${
                                isPointerDown && "before:pl-w-7 before:pl-h-3"
                            }`}
                            style={{ width: conditions(ConditionName.isLive) ? "100%" : `${(currentTime / duration) * progressBarWidth()}px` }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
